import type { SVGProps } from "react";
const SvgCarryOnBaggageDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <radialGradient
        id="carryOnBaggageDisabled_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.3 0 0 1.3 21.34 28.208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.462} stopColor="#BCBCBC" />
        <stop offset={0.759} stopColor="#A2A2A2" />
        <stop offset={0.829} stopColor="#AAA" />
      </radialGradient>
      <radialGradient
        id="carryOnBaggageDisabled_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.3 0 0 1.3 10.65 28.208)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.462} stopColor="#BCBCBC" />
        <stop offset={0.759} stopColor="#A2A2A2" />
        <stop offset={0.829} stopColor="#AAA" />
      </radialGradient>
      <radialGradient
        id="carryOnBaggageDisabled_svg__e"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.2 7.9 -13.5 .4 16 19.5)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.63} stopColor="#DEDEDE" />
        <stop offset={1} stopColor="#C5C5C5" />
      </radialGradient>
      <linearGradient
        id="carryOnBaggageDisabled_svg__b"
        x1={21.341}
        x2={21.341}
        y1={27.546}
        y2={28.114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="carryOnBaggageDisabled_svg__d"
        x1={10.649}
        x2={10.649}
        y1={27.546}
        y2={28.114}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <filter
        id="carryOnBaggageDisabled_svg__f"
        width={20.6}
        height={3.8}
        x={5.793}
        y={27.645}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={0.75} />
      </filter>
    </defs>
    <path
      fill="#DBDBDB"
      d="M18.004 3.473h-4.011v12.112h-1.337V3.473c0-.738.599-1.336 1.337-1.336h4.01c.739 0 1.338.598 1.338 1.336v12.112h-1.337z"
    />
    <path
      fill="url(#carryOnBaggageDisabled_svg__a)"
      d="M21.34 29.545a1.337 1.337 0 1 0 0-2.674 1.337 1.337 0 0 0 0 2.674"
    />
    <path
      fill="url(#carryOnBaggageDisabled_svg__b)"
      d="M21.34 26.871c.74 0 1.338.598 1.338 1.337h-2.674c0-.739.598-1.337 1.337-1.337Z"
      opacity={0.3}
    />
    <path
      fill="url(#carryOnBaggageDisabled_svg__c)"
      d="M10.65 29.545a1.337 1.337 0 1 0 0-2.674 1.337 1.337 0 0 0 0 2.674"
    />
    <path
      fill="url(#carryOnBaggageDisabled_svg__d)"
      d="M10.65 26.871c.738 0 1.336.598 1.336 1.337H9.313c0-.739.599-1.337 1.338-1.337Z"
      opacity={0.3}
    />
    <path
      fill="url(#carryOnBaggageDisabled_svg__e)"
      d="M21.742 11.645H10.244a2.005 2.005 0 0 0-2.006 2.005v11.887c0 1.108.898 2.006 2.006 2.006h11.498a2.005 2.005 0 0 0 2.005-2.006V13.65a2.005 2.005 0 0 0-2.005-2.005"
    />
    <path
      fill="#1C1C1C"
      d="M13.729 13.848a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .668 0V14.182a.334.334 0 0 0-.334-.334m2.269 0a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .669 0V14.182a.334.334 0 0 0-.335-.334m2.266 0a.334.334 0 0 0-.334.334v10.825a.334.334 0 0 0 .668 0V14.182a.334.334 0 0 0-.334-.334"
      opacity={0.2}
    />
    <path
      fill="#B4B4B4"
      d="M19.337 4.142h-6.685v-.668c0-.739.599-1.337 1.337-1.337H18c.739 0 1.337.598 1.337 1.337z"
    />
    <g filter="url(#carryOnBaggageDisabled_svg__f)" opacity={0.5}>
      <ellipse cx={16} cy={29.544} fill="#000" rx={8.8} ry={0.4} />
    </g>
    <path stroke="#fff" strokeWidth={4} d="M5 29.512 25.516 9" />
    <path stroke="#B4B4B4" strokeWidth={1.5} d="M6 30.512 26.516 10" />
  </svg>
);
export default SvgCarryOnBaggageDisabled;
